import { useColorModeValue } from "@chakra-ui/react";

/** Glass-style panel props for cards/sections over {@link PublicAmbient3D}. */
export function usePublicGlassSurface() {
  const bg = useColorModeValue(
    "rgba(255, 255, 255, 0.72)",
    "rgba(30, 41, 59, 0.68)"
  );
  const borderColor = useColorModeValue(
    "rgba(45, 212, 191, 0.2)",
    "rgba(94, 234, 212, 0.16)"
  );
  const boxShadow = useColorModeValue(
    "0 4px 24px -4px rgba(15, 118, 110, 0.12), 0 22px 56px -28px rgba(15, 118, 110, 0.28), inset 0 1px 0 rgba(255, 255, 255, 0.75)",
    "0 8px 32px -8px rgba(0, 0, 0, 0.55), inset 0 1px 0 rgba(255, 255, 255, 0.07)"
  );

  return {
    bg,
    borderColor,
    boxShadow,
    backdropFilter: "blur(14px)",
    WebkitBackdropFilter: "blur(14px)",
  };
}

export function usePublicGlassStrip() {
  const bg = useColorModeValue(
    "rgba(240, 253, 250, 0.55)",
    "rgba(15, 23, 42, 0.45)"
  );
  const borderColor = useColorModeValue(
    "rgba(45, 212, 191, 0.18)",
    "rgba(94, 234, 212, 0.12)"
  );
  return {
    bg,
    borderColor,
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)",
  };
}
